export default __webpack_public_path__ + "assets/30e2baa90d4d52de1852b6dd1e4e9bd9.png";